import React, { useEffect, useState } from "react";
//Redux
import { useDispatch } from "react-redux";
// Components
import { ConfigurationPanel } from "../..";
import { BsPrinter } from "react-icons/bs";
import { Button, translateMessage } from "@delibrandev/utils";
import "./style.css";
import { Input } from "@delibrandev/utils";
import { Select } from "@delibrandev/utils";
// API
import { createPrinter, deletePrinter, getPrinters, updatePrinter } from "../../../../../../api/printers";
import { setAlert } from "../../../../../../reducers/userConfigSlice";
import { getOrderManagers, getSalesPoints } from "../../../../../../api/configuration";

export const Printers = () => {
  const dispatch = useDispatch();
  const [printers, setPrinters] = useState([]);
  const [orderManagers, setOrderManagers] = useState([]);
  const [salesPoint, setSalesPoint] = useState([]);
  const [newPrinter, setNewPrinter] = useState({ name: "", ip: "", port: "", orderManagerConfigurationId: null, pointOfSaleConfigurationId: null });

  const query = async () => {
    const response = await getPrinters();
    if (response && !response.error) {
      setPrinters(response.data);
    }

    try {
      const payload = {};
      const response = await getSalesPoints(payload);
      if (response && !response.error) {
        setSalesPoint(response.data);
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }

    try {
      const payload = {};
      const response = await getOrderManagers(payload);
      if (response && !response.error) {
        setOrderManagers(response.data);
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }
  };

  useEffect(() => {
    query();
  }, []);

  const handleInputChange = (setState, key, value) => {
    setState((prevState) => ({ ...prevState, [key]: value }));
  };

  const handleCreatePrinter = async () => {
    try {
      const response = await createPrinter(newPrinter);
      if (response && !response.error) {
        setNewPrinter({ name: "", ip: "", port: "" });
        document.getElementById("newPrinterName").value = "";
        document.getElementById("newPrinterIp").value = "";
        document.getElementById("newPrinterPort").value = "";
        query();
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      }
    } catch (error) {
      console.error("Error al crear la impresora:", error);
    }
  };

  const handleUpdatePrinter = async (printerId, updatedPrinter) => {
    console.log("updatedPrinter: ", updatedPrinter);
    try {
      const response = await updatePrinter(printerId, updatedPrinter);
      if (response && !response.error) {
        setPrinters((prevPrinters) => prevPrinters?.map((printer) => (printer.printerId === printerId ? updatedPrinter : printer)));
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      }
    } catch (error) {
      console.error("Error al actualizar la impresora:", error);
    }
  };

  const handleDeletePrinter = async (id) => {
    try {
      const response = await deletePrinter(id);
      if (response && !response.error) {
        setPrinters((prevPrinters) => prevPrinters.filter((printer) => printer.printerId !== id));
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      }
    } catch (error) {
      console.error("Error al eliminar la impresora:", error);
    }
  };

  const PrinterDesign = ({ data }) => {
    const [editingPrinter, setEditingPrinter] = useState({ ...data });

    return (
      <div className="col-md-4 col-sm-12">
        <ConfigurationPanel
          title=""
          hasButtonSave={false}
          content={
            <div className="printer-container">
              <div className="printer-icon">
                <BsPrinter color={"var(--color-process)"} />
              </div>
              <div className="printer-row">
                <Input
                  id={`namePrinterInput`}
                  type="text"
                  placeholder="Nombre de la impresora"
                  icon={null}
                  classname="w-100"
                  iconPositionRight={true}
                  label="Nombre"
                  description=""
                  onChange={(e) => handleInputChange(setEditingPrinter, "name", e)}
                  defaultValue={editingPrinter.name}
                />
              </div>
              <div className="printer-row">
                <Input
                  id={`ipPrinterInput`}
                  type="text"
                  placeholder="Dirección IP"
                  icon={null}
                  classname="w-100"
                  iconPositionRight={true}
                  label="Dirección IP"
                  description=""
                  onChange={(e) => handleInputChange(setEditingPrinter, "ip", e)}
                  defaultValue={editingPrinter.ip}
                />
              </div>
              <div className="printer-row">
                <Input
                  id={`portPrinterInput`}
                  type="text"
                  placeholder="Puerto"
                  icon={null}
                  classname="w-100"
                  iconPositionRight={true}
                  label="Puerto"
                  description=""
                  onChange={(e) => handleInputChange(setEditingPrinter, "port", e)}
                  defaultValue={editingPrinter.port}
                />
              </div>
              <div className="printer-row">
                <Select
                  value={
                    editingPrinter?.OrderManagerConfiguration?.orderManagerConfigurationId
                      ? editingPrinter?.OrderManagerConfiguration?.orderManagerConfigurationId
                      : null
                  }
                  values={[
                    { id: null, name: "Sin seleccionar" },
                    ...orderManagers.map((o) => ({
                      id: o.orderManagerConfigurationId,
                      name: o.name,
                    })),
                  ]}
                  callback={(e) => handleInputChange(setEditingPrinter, "orderManagerConfigurationId", e)}
                  label="Gestor de pedidos"
                  description=""
                  classname=""
                />
              </div>
              <div className="printer-row">
                <Select
                  value={
                    editingPrinter?.PointOfSaleConfiguration?.PointOfSaleConfigurationId
                      ? editingPrinter?.PointOfSaleConfiguration?.PointOfSaleConfigurationId
                      : null
                  }
                  values={[
                    { id: null, name: "Sin seleccionar" },
                    ...salesPoint.map((o) => ({
                      id: o.PointOfSaleConfigurationId,
                      name: o.name,
                    })),
                  ]}
                  callback={(e) => handleInputChange(setEditingPrinter, "pointOfSaleConfigurationId", e)}
                  label="Punto de venta"
                  description=""
                  classname=""
                />
              </div>
              <div className="printer-actions">
                <Button text="Eliminar" icon={null} customClass="" action={() => handleDeletePrinter(data.printerId)} />
                <Button text="Actualizar" icon={null} customClass="" action={() => handleUpdatePrinter(data.printerId, editingPrinter)} />
                <Button text="Prueba" icon={null} customClass="customButtonColor2" action={() => null} />
              </div>
            </div>
          }
        />
      </div>
    );
  };

  return (
    <div className="row">
      {printers?.map((printer) => (
        <PrinterDesign key={printer.printerId} data={printer} />
      ))}
      <div className="col-md-4 col-sm-12">
        <ConfigurationPanel
          title=""
          hasButtonSave={false}
          content={
            <div className="printer-container">
              <div className="printer-icon">
                <BsPrinter />
              </div>
              <div className="printer-name">Agregar impresora</div>
              <div className="printer-row">
                <Input
                  id="newPrinterName"
                  type="text"
                  placeholder="Nombre de la impresora"
                  icon={null}
                  classname="w-100"
                  iconPositionRight={true}
                  label="Nombre"
                  description=""
                  value={newPrinter.name}
                  onChange={(e) => handleInputChange(setNewPrinter, "name", e)}
                />
              </div>
              <div className="printer-row">
                <Input
                  id="newPrinterIp"
                  type="text"
                  placeholder="Dirección IP"
                  icon={null}
                  classname="w-100"
                  iconPositionRight={true}
                  label="Dirección IP"
                  description=""
                  value={newPrinter.ip}
                  onChange={(e) => handleInputChange(setNewPrinter, "ip", e)}
                />
              </div>
              <div className="printer-row">
                <Input
                  id="newPrinterPort"
                  type="text"
                  placeholder="Puerto"
                  icon={null}
                  classname="w-100"
                  iconPositionRight={true}
                  label="Puerto"
                  description=""
                  value={newPrinter.port}
                  onChange={(e) => handleInputChange(setNewPrinter, "port", e)}
                />
              </div>
              <div className="printer-actions">
                <Button text="Agregar" icon={null} customClass="" action={handleCreatePrinter} />
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};
